module.exports = __webpack_public_path__ + "system/media/tip.fca70946.mp3";